import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import axiosInstance, { keyLogin, fronturl } from "../../axiosInstance";
import { useDispatch } from "react-redux";
import { authActions } from "../../redux/store";
import { toast } from "react-hot-toast";
import setCookie from "../../helpers/setCookie";
import { encrypt } from "../../helpers/encryption";
import getCookie from "../../helpers/getCookie";
import getDecryptData from "../../helpers/getDecryptData";

const getDashboardRoute = (type) => {
  if (Number(type) === 0) return "/dashboard";
  if (Number(type) === 2) return "/job-seeker/dashboard";
  if (Number(type) === 1 || Number(type) === 3) return "/recruiter/dashboard";
  return "/";
};

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [inputs, setInputs] = useState({ email: "", password: "" });

  useEffect(() => {
    const checkUserToken = async () => {
      const usertoken = getCookie("token");
      if (usertoken) {
        const existingSession = await getDecryptData();
        if (existingSession?.type !== undefined) {
          navigate(getDashboardRoute(existingSession.type));
        }
      }
    };
    checkUserToken();
  }, [dispatch, navigate]);

  const handleChange = (e) => {
    setInputs((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await toast.promise(axiosInstance.post(`/user-login-all`, inputs), {
        loading: "Login...",
        success: "Login successful",
        error: "Failed to login.",
      });

      const { success, admin, message } = data;
      if (success) {
        if (admin) {
          const { _id, username, email, type, token, normalizedRole } = admin;
          const userToStore = { _id, username, email, type, token, normalizedRole };
          const encryptedData = encrypt(JSON.stringify(userToStore), keyLogin);
          setCookie("token", encryptedData, 7);
          window.dispatchEvent(
            new CustomEvent("ynb-auth-changed", {
              detail: userToStore,
            })
          );
        }

        dispatch(authActions.login());
        navigate(getDashboardRoute(admin?.type));
      } else {
        toast.error(message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Login failed");
    }
  };

  return (
    <>
      <Helmet>
        <title>Login | YNB Jobs</title>
      </Helmet>
      <div className="portal-auth-shell">
        <div className="portal-container">
          <div className="portal-login-simple-wrap">
            <div className="portal-auth-card portal-login-card">
              <Link className="portal-login-back portal-login-back-light mb-2 d-inline-block" to="/">
                Back to Home
              </Link>

              <div className="mb-4">
                 <h1 className="portal-title-sm mb-2">Login</h1>
                <p className="portal-muted mb-0">Enter your email and password to continue.</p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="portal-input"
                    id="email"
                    value={inputs.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">Password</label>
                  <input
                    type="password"
                    className="portal-input"
                    id="password"
                    name="password"
                    onChange={handleChange}
                    required
                    placeholder="Enter your password"
                    value={inputs.password}
                  />
                </div>
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
                  <Link to="/contact" className="portal-btn-link">Lost password?</Link>
                  <Link to="/register" className="portal-btn-link">Create account</Link>
                </div>
                <button type="submit" className="portal-btn-primary w-100">Sign in</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
